<app-popup
  [heading]="'File Operations: ' + file.blob_name"
  [showFooterButtons]="false"
  [showCloseIcon]="true"
  (cancelClicked)="onClose()"
>
  <div class="operations-container">
    @for (operation of file.operations; track operation.operation_id) {
      <div class="operation-card">
        <div class="operation-header">
          <div class="operation-info">
            <h3 class="operation-name">{{ operation.operation_name }}</h3>
            <span
              class="operation-status"
              [ngClass]="getStatusClass(operation.status)"
            >
              {{ operation.status }}
            </span>
          </div>
          <div class="operation-date">
            {{ operation.performed_datetime | date: "medium" }}
          </div>
        </div>

        @if (
          operation.operation_name === "Portfolio Mining" &&
          operation.status.toLowerCase() === "failed"
        ) {
          <div class="failure-message">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="#dc2626"
            >
              <path
                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
              />
            </svg>
            <div class="failure-content">
              <div class="failure-title">Operation Failed</div>
            </div>
            <button
              type="button"
              class="retrigger-btn"
              [class.disabled]="isRetriggering"
              [class.processing]="isRetriggering"
              [disabled]="isRetriggering"
              (click)="onRetrigger(file.id)"
              title="Retrigger Portfolio Mining"
            >
              @if (isRetriggering) {
                <app-svg-icon
                  [iconName]="'spinner.svg'"
                  [width]="'16px'"
                  [height]="'16px'"
                  [style.fill]="'currentColor'"
                ></app-svg-icon>
                <span>Processing...</span>
              } @else {
                <app-svg-icon
                  [iconName]="'revert.svg'"
                  [width]="'16px'"
                  [height]="'16px'"
                  [style.fill]="'currentColor'"
                ></app-svg-icon>
                <span>Retry</span>
              }
            </button>
          </div>
        }

        @if (hasErrors(operation)) {
          <div class="errors-section">
            <div class="errors-header">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="#dc2626"
              >
                <path
                  d="M12 2L1 21h22L12 2zm0 3.99L19.53 19H4.47L12 5.99zM11 16v2h2v-2h-2zm0-6v4h2v-4h-2z"
                />
              </svg>
              <span>Errors Found</span>
            </div>

            @if (
              operation.errors.missing_fields &&
              operation.errors.missing_fields.length > 0
            ) {
              <div class="error-block">
                <strong>Missing Required Fields:</strong>
                <ul>
                  @for (field of operation.errors.missing_fields; track field) {
                    <li>{{ field }}</li>
                  }
                </ul>
              </div>
            }

            @if (
              operation.errors.missing_columns &&
              operation.errors.missing_columns.length > 0
            ) {
              <div class="error-block">
                <strong>Missing Columns:</strong>
                <ul>
                  @for (
                    column of operation.errors.missing_columns;
                    track column
                  ) {
                    <li>{{ column }}</li>
                  }
                </ul>
              </div>
            }

            @if (
              operation.errors.messages && operation.errors.messages.length > 0
            ) {
              <div class="error-block">
                <strong>Validation Messages:</strong>
                <ul>
                  @for (message of operation.errors.messages; track message) {
                    <li>{{ message }}</li>
                  }
                </ul>
              </div>
            }
          </div>
        } @else {
          @if (
            operation.status.toLowerCase() === "success" ||
            operation.status.toLowerCase() === "completed"
          ) {
            <div class="success-message">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="#059669"
              >
                <path
                  d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
                />
              </svg>
              <div class="success-content">
                <div class="success-title">
                  Operation Completed Successfully
                </div>
                <div class="success-subtitle">No errors or issues detected</div>
              </div>
            </div>
          }
        }
      </div>
    } @empty {
      <div class="no-operations">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="48"
          height="48"
          viewBox="0 0 24 24"
          fill="#9ca3af"
        >
          <path
            d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
          />
        </svg>
        <p>No operations found for this file</p>

        @if (isPortfolioMiningAvailable) {
          <div class="retrigger-container mt-3">
            <a
              href="javascript:void(0)"
              class="enable-mining-btn"
              [class.disabled]="isRetriggering"
              [class.processing]="isRetriggering"
              (click)="onRetrigger(file.id)"
            >
              @if (isRetriggering) {
                Processing...
              } @else {
                Enable Portfolio Mining
              }
            </a>
          </div>
        }
      </div>
    }
  </div>
</app-popup>
